import { useMutation, useQueryClient } from '@tanstack/react-query';
import expensesApi from '@/features/dashboard/expenses/api/expensesApi.ts';
import { expensesApiQueryKeys } from '@/features/dashboard/expenses/api/expensesApi.queryKeys.ts';
import { PayTourExpenseRequestDto } from '@/features/dashboard/expenses/types/PayExpenseRequest.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';
import { invalidateAttentionQueries } from '@/utils/invalidateAttentionQueries.ts';
import { toast } from 'sonner';

interface PayExpenseParams {
  expenseId: string;
  request: PayTourExpenseRequestDto;
}

export default function usePayExpense(tourId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ expenseId, request }: PayExpenseParams) =>
      expensesApi.pay(tourId, expenseId, request),
    onSuccess: (_data, { expenseId }) => {
      invalidateFinanceRelatedQueries(queryClient);
      queryClient.invalidateQueries({
        queryKey: expensesApiQueryKeys.byId(tourId, expenseId),
      });
      void invalidateAttentionQueries(queryClient, tourId);
      toast.success('Zapłata została zarejestrowana');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas rejestrowania zapłaty.',
      });
    },
  });
}
